import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareBoardRoute: InvariantJiraRoute = {
	name: 'software-boards',
	exact: true,
	path: '/jira/software/projects/:projectKey/boards/:boardId',
};
